import styled from 'styled-components';

export const StyledCurrenciesDropdown = styled.div`
  & .MuiInputBase-root {
    width: 7rem;
    margin-right: 1rem;
  }
`;
